export const dropdown = [
  { name: "By Popularity", path: "popularity.desc" },
  { name: "By Revenue", path: "revenue.desc" },
  { name: "By Vote Count", path: "vote_count.desc" },
  { name: "Random", path: "popularity.desc" },
];
